import moment from 'moment'

/**
 * A grid filter for a date column whose cells hold a full timestamp (a
 * termination is stamped with the ledger time): a row passes when its value
 * falls on the day picked in the filter. No filter value passes every row.
 */
export const onSameDay = (
  row: { getValue: (columnId: string) => unknown },
  columnId: string,
  filterValue: unknown,
) => {
  if (!filterValue) return true
  const value = row.getValue(columnId)
  return !!value && moment(value as Date).isSame(filterValue as Date, 'day')
}

/** An ISO timestamp as a Date for a grid cell; null stays null. */
export const timestampToDate = (value: string | null | undefined): Date | null =>
  value ? new Date(value) : null
